import { initMainHeaderNav } from "./nav-sub-menus";
import { initMainMenuPopup } from "./main-menu-popup";
import { init as initScrolledBodyClass } from "./scrolled-body-class";
import { init as initBannerScrollBtns } from "./scroll-down-button";
import { init as initSearchPopout } from "./search-popout";
import { init as initCf7 } from "./cf7";
import { init as initLinkScroll } from "./link-scroll";
import { init as initLoadMore } from "./load-more";
import { init as initMailSignup } from "./mail-signup";
import { init as initBanner } from "./banner";
import { init as initImageSlider } from "./image-slider";
import { initCustomSelects } from "./custom-select";
import { initCustomFileInputs } from "./custom-file-input";
import { initCustomCheckboxes } from "./custom-checkbox";
import { initCustomRadios } from "./custom-radio";
import { initCustomRanges } from "./custom-range-input";
import { initCf7FileInputs } from "./cf7-file-inputs";
import { initItemSliders } from "./item-slider";
import { initAllPopups, initAllPopupBtns } from "./popup";
import { initRiseUpFallDown } from "./rise-up-fall-down";
import { initFiniteEqualWidthSliders } from "./finite-equal-width-slider";
import { initInfiniteUnidirectionalAutoSliders } from "./infinite-unidirectional-auto-slider";
import { initInfiniteSliders } from "./infinite-slider";
import { initSearchPopup } from "./search-popup";
import { initVideoPopup } from "./video-popup";
import { initShareLinks } from "./share-links";
import { initPostsPagination } from "./posts-pagination";
import { initLogoLinkAltImages } from "./logo-link-alt-images";
import { initAltBgdImages } from "./alternative-background-images";
import { initTabbedContent } from "./tabbed-content";
import { initCollapsibleSections } from "./collapsible-sections";
import { initLazyThumbnails } from "./lazy-thumbnails";
import { initStretchText } from "./stretch-text";
import { initHeaderLogoUrlOnScroll } from "./header-logo-url";
import { initAddToCart } from "./add-to-cart";
import { initMatchHeight } from "./match-height";
import { initSpacers } from "./spacers";
import { debugShowViewportDimensions } from "./utils/misc";
import { initTimepickers } from "./timepicker";
import { initWysiwygs } from "./wysiwyg";

declare const jQuery: any;

//import "./jquery-easing";
import "./lightbox-hacked";
import "./jquery-scrollto-hacked";
import "./window-scroll-offset";
import "./file-upload-widget";
import "./back-to-top";
import "./drag";
import "./wheel";
import "./modal";
import "./utils/css";
import "./tooltip";

initSpacers();
initScrolledBodyClass();
initMatchHeight();
initAltBgdImages();
initLogoLinkAltImages();
initBanner();
initBannerScrollBtns();
initMainMenuPopup();
initRiseUpFallDown();
initMainHeaderNav();
initSearchPopout();
initCf7();
initCf7FileInputs();
initCustomFileInputs();
initLinkScroll();
initLoadMore();
initImageSlider();
initMailSignup();
initCustomSelects();
initCustomCheckboxes();
initCustomRadios();
initCustomRanges();
initItemSliders();
initAllPopups();
initAllPopupBtns();
initFiniteEqualWidthSliders();
initInfiniteSliders();
initInfiniteUnidirectionalAutoSliders();
initSearchPopup();
initVideoPopup();
initShareLinks();
initPostsPagination();
initTabbedContent();
initCollapsibleSections();
initLazyThumbnails();
initStretchText();
initHeaderLogoUrlOnScroll();
initTimepickers();
initAddToCart();
initWysiwygs();

// ----------------------------------------------------------------------
// IE/Edge CSS object-fit polyfill
// https://www.npmjs.com/package/object-fit-images
require("object-fit-images")();
require("object-fit-videos")();
// ----------------------------------------------------------------------

debugShowViewportDimensions();
